//RUTAS UTILITARIAS
//--Switch entities
export const urlSwitchEntities = "/api/entities-switch";